import theme from 'theme.json';

// Based on "mb-2" + limited possible styles in https://stripe.com/docs/js/appendix/style, please keep up to date
export const inputPaymentStyle = {
  base: {
    fontSize: '16px',
    fontFamily: 'var(--font-jost)',
    color: theme.extend.colors.quaternary[300],
    background: 'white',
    '::placeholder': {
      color: theme.extend.colors.tertiary[300]
    }
  },
  invalid: {
    color: theme.extend.colors.secondary.red
  }
};
